import React from 'react';
import {
  FDBackButton,
  FDBadge, FDBodyText, FDPrimaryActionButton,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import {
  useEmailTabContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/EmailTabContext';
import FileUploader from 'Components/Files/Uploader';
import FileChips from 'Components/UI/FileChips';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FILE_UPLOAD_TYPES } from 'Consts/Queries';
import {
  EMAIL_EDITOR_SECTION,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections';
import { SectionPaper } from '../SectionPaper';

export const AttachmentsSection = ({ setCurrentSection }) => {
  const {
    agendaResource,
    refreshAttachments,
    attachmentCollection,
    householdResource,
    loadingAttachments,
    onStartFileUpload,
    onFinishFileUpload,
    setAttachmentProgress,
    attachmentProgress,
  } = useEmailTabContext();
  const { displayErrorMessage } = useSnackbarContext();

  const showAttachments = attachmentCollection && attachmentCollection?.resources().length() > 0;
  const showEmptyState = !loadingAttachments && !showAttachments;
  const attachmentCount = attachmentCollection?.resources().length();
  const progressLabel = attachmentProgress === 100 ? 'Processing' : `${attachmentProgress}%`;
  const buttonLabel = loadingAttachments ? progressLabel : 'Upload file';


  return (
    <SectionPaper height={'100%'} flex={1}>
      <FDStack direction={'column'} justifyContent={'space-between'} height={'100%'}>
        <FDStack direction={'column'} spacing={4}>
          <FDStack spacing={3} alignItems={'center'}>
            <FDTitleText value={'Attachments'} />
            <FDBadge appearance="standard" value={attachmentCount} />
          </FDStack>
          <FDStack direction={'column'} alignItems={'flex-start'} spacing={4} width={'100%'}>
            {showAttachments ? (
              <FDStack justifyContent={'flex-start'} wrap>
                <FileChips
                  fileCollection={attachmentCollection}
                  onDelete={refreshAttachments}
                />
              </FDStack>
            ) : null}
            {showEmptyState ? <FDBodyText
              value={'This agenda has no attachments'}
              align={'center'}
            /> : null}
          </FDStack>
        </FDStack>
        <FDStack direction={'row'} justifyContent={'space-between'} paddingY={1}>
          <FDBackButton onClick={() => setCurrentSection(EMAIL_EDITOR_SECTION)} size={'lg'} />
          <FileUploader
            params={{
              type: FILE_UPLOAD_TYPES.emailAttachment,
              meetingAgendaId: agendaResource?.id(),
              householdId: householdResource.id(),
            }}
            disableClick={loadingAttachments}
            onStart={onStartFileUpload}
            onFinally={onFinishFileUpload}
            onCatch={err => displayErrorMessage(err, 'Could not attach document')}
            onSuccess={refreshAttachments}
            successToastMessage="Attachment uploaded successfully"
            setUploadProgress={setAttachmentProgress}
          >
            <FDPrimaryActionButton
              label={buttonLabel}
              icon={loadingAttachments ? undefined : 'add'}
              size={'lg'}
            />
          </FileUploader>
        </FDStack>
      </FDStack>
    </SectionPaper>
  );
};

AttachmentsSection.propTypes = {
  setCurrentSection: PropTypes.func.isRequired,
};
